import { makeStyles } from 'tss-react/mui';

export const useProgressStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
  },
  label: {
    textBox: 'trim-both cap alphabetic',
  },
  ring: {
    position: 'relative',
    display: 'flex',
  },
  track: {
    color: theme.palette.custom.border.primary,
  },
  completedTrack: {
    color: theme.palette.custom.status.success,
  },
  arc: {
    position: 'absolute',
    top: 0,
    left: 0,
    color: theme.palette.custom.status.success,
  },
  excessArc: {
    color: theme.palette.custom.status.progress,
  },
}));
